import { createFileRoute } from '@tanstack/react-router'
import { IntegrationsSettings } from '@/features/organizations/settings/integrations'
import { z } from 'zod'

const searchSchema = z.object({
  xero_status: z.enum(['success', 'error']).optional(),
  xero_message: z.string().optional(),
  xero_tenant: z.string().optional(),
  // DocuSign OAuth callback returns here with the outcome.
  esign: z.enum(['connected', 'error']).optional(),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/integrations',
)({
  component: IntegrationsSettings,
  validateSearch: searchSchema,
})
